import deepmerge from 'deepmerge';
import deDe from './de-DE.json';
import deDePolite from '../default/de-DE_polite.json';
import deDeDefault from '../default/de-DE.json';
var messages = {
    'de-DE': deepmerge.all([deDeDefault, deDePolite, deDe]),
};
export default messages;
//# sourceMappingURL=index.js.map